var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZfv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 46.2 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M19.5 66.3V53.7h7.7M19.5 60h7.7M32.6 53.6l6 12.8 5.3-12.8M2.2 53.6h10.5L2.2 66.4h10.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZfv);
export default __webpack_public_path__ + "static/media/ZFV.e1b395990b4e0393ec0eb7e7de7dbef9.svg";
export { ForwardRef as ReactComponent };